import type { ReactNode } from 'react';

/** ავტორიზაციის გვერდების საერთო გარსი — ლოგო, სათაური, ბარათი */
export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
}) {
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-7 flex flex-col items-center gap-3 text-center">
          <img src="/step-logo.png" alt="STEP IT Academy" className="size-16 object-contain" />
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-ink">{title}</h1>
            {subtitle && <p className="text-[13px] text-ink-mute">{subtitle}</p>}
          </div>
        </div>
        <div className="rounded-[10px] border border-line bg-surface p-6 shadow-xs">{children}</div>
      </div>
    </div>
  );
}

/** პაროლის მოთხოვნები — API-ს წესების სარკე (auth.schema.ts) */
export const PASSWORD_RULES: { test: (v: string) => boolean; label: string }[] = [
  { test: (v) => v.length >= 8, label: 'მინიმუმ 8 სიმბოლო' },
  { test: (v) => /[a-z]/.test(v), label: 'პატარა ლათინური ასო' },
  { test: (v) => /[A-Z]/.test(v), label: 'დიდი ლათინური ასო' },
  { test: (v) => /[0-9]/.test(v), label: 'ციფრი' },
];

/** მოთხოვნების სია მონიშვნებით */
export function PasswordRules({ value }: { value: string }) {
  return (
    <ul className="space-y-1">
      {PASSWORD_RULES.map((rule) => {
        const ok = rule.test(value);
        return (
          <li
            key={rule.label}
            className={`flex items-center gap-2 text-[12px] ${ok ? 'text-ok' : 'text-ink-mute'}`}
          >
            <span
              className={`inline-block size-1.5 rounded-full ${ok ? 'bg-ok' : 'bg-line-strong'}`}
            />
            {rule.label}
          </li>
        );
      })}
    </ul>
  );
}
